import type { DetailType } from "#shared/schemas/entityDetail.ts";
import { DETAIL_TYPES } from "#shared/schemas/entityDetail.ts";
import { useBrowseTrailStore } from "@web/stores/browseTrail.ts";
import { useDetailStore, type DetailTarget } from "@web/stores/detail.ts";
import { useGlobeStore } from "@web/stores/globe.ts";
import { useUiStore } from "@web/stores/ui.ts";

const TYPE_SET = new Set<string>(DETAIL_TYPES);

/** `track:abc123` — one sheet param, current entity only. */
export function formatSheetParam(type: DetailType, id: string): string {
  return `${type}:${id}`;
}

export function parseSheetParam(
  raw: string | null | undefined,
): DetailTarget | null {
  if (!raw) return null;
  const idx = raw.indexOf(":");
  if (idx <= 0) return null;
  const type = raw.slice(0, idx);
  const id = raw.slice(idx + 1).trim();
  if (!TYPE_SET.has(type) || !id) return null;
  return { type: type as DetailType, id };
}

/** Close sheet and wipe the dive trail + URL sheet param (caller syncs URL). */
export function closeDetailSheet(): void {
  useBrowseTrailStore.getState().clear();
  useDetailStore.getState().setTarget(null);
  useGlobeStore.getState().clearCountryPanel();
  useUiStore.getState().setSheetOpen(false);
}
